import React, { useState, useEffect } from "react";
import { Modal, Input, Checkbox, Button, Row, Col, Form } from "antd";
import { IGGOptions } from "../../../../../Data/data";

const AddIGGModal = ({ visible, onOk, onCancel, responeData, errors }) => {
  const [form] = Form.useForm();
  const [selectedParams, setSelectedParams] = useState([]);
  const [customParams, setCustomParams] = useState([]);

  useEffect(() => {
    if (visible) {
      const defaultParams =
        responeData?.selected_parameters || IGGOptions.map((param) => param.value);
      setSelectedParams(defaultParams);
      form.setFieldsValue({
        igg_name: responeData?.igg_name || "",
        igg_maker: responeData?.igg_maker || "",
        igg_model: responeData?.igg_model || "",
      });
      setCustomParams(
        Array.isArray(responeData?.other_parameters) ? responeData.other_parameters : []
      );
    }
  }, [visible, responeData]);

  useEffect(() => {
    if (errors && Object.keys(errors).length > 0) {
      const fieldErrors = Object.keys(errors).map((key) => ({
        name: key,
        errors: [errors[key]],
      }));
      form.setFields(fieldErrors);
    }
  }, [errors, form]);

  const handleAddParam = () => {
    setCustomParams([...customParams, { name: "", unit: "" }]);
  };

  const handleCustomChange = (index, field, value) => {
    const updated = [...customParams];
    updated[index][field] = value;
    setCustomParams(updated);
  };

  const handleDeleteParam = (index) => {
    setCustomParams(customParams.filter((_, i) => i !== index));
  };

  const handleSubmit = () => {
    form
      .validateFields()
      .then((values) => {
        const data = {
          ...values,
          selectedParams,
          customParams,
        };
        onOk(data);
        form.resetFields();
        setSelectedParams(IGGOptions.map((param) => param.value));
        setCustomParams([]);
      })
      .catch((errorInfo) => {
        console.log("Validation Failed:", errorInfo);
      });
  };

  const safeIGGOptions = Array.isArray(IGGOptions) && IGGOptions.length > 0 ? IGGOptions : [];

  return (
    <Modal
      title="Add IGG Details"
      visible={visible}
      onCancel={() => {
        onCancel();
        form.resetFields();
        setSelectedParams([]);
        setCustomParams([]);
      }}
      onOk={handleSubmit}
      okText="Save"
    >
      <Form
        layout="vertical"
        form={form}
        onValuesChange={(changedValues) => {
          Object.keys(changedValues).forEach((key) => {
            form.setFields([{ name: key, errors: [] }]);
          });
        }}
      >
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Form.Item
              label="IGG Name"
              name="igg_name"
              rules={[{ required: true, message: "Please enter IGG Name" }]}
            >
              <Input placeholder="IGG Name" maxLength={50} />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item
              label="IGG Maker"
              name="igg_maker"
              rules={[{ required: true, message: "Please enter IGG Maker" }]}
            >
              <Input placeholder="IGG Maker" maxLength={50} />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item
              label="IGG Model"
              name="igg_model"
              rules={[{ required: true, message: "Please enter IGG Model" }]}
            >
              <Input placeholder="IGG Model" maxLength={50} />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item label="Select IGG Parameters to Log">
              {safeIGGOptions.length > 0 ? (
                <Checkbox.Group
                  value={selectedParams}
                  onChange={(values) => setSelectedParams(values)}
                  style={{ width: "100%" }}
                >
                  <Row gutter={[8, 8]}>
                    {safeIGGOptions.map((param) => (
                      <Col span={12} key={param.value}>
                        <Checkbox value={param.value}>{param.label}</Checkbox>
                      </Col>
                    ))}
                  </Row>
                </Checkbox.Group>
              ) : (
                <div style={{ color: "red" }}>No IGG parameters available</div>
              )}
            </Form.Item>
          </Col>

          <Col span={24}>
            <div style={{ marginTop: 16 }}>
              <b>Add Other Parameters</b>
              {customParams.map((param, index) => (
                <Row gutter={8} key={index} style={{ marginTop: 8 }}>
                  <Col span={10}>
                    <Input
                      placeholder="Parameter"
                      value={param.name}
                      maxLength={50}
                      onChange={(e) => handleCustomChange(index, "name", e.target.value)}
                    />
                  </Col>
                  <Col span={10}>
                    <Input
                      placeholder="Unit"
                      value={param.unit}
                      maxLength={10}
                      onChange={(e) => handleCustomChange(index, "unit", e.target.value)}
                    />
                  </Col>
                  <Col span={4}>
                    <Button danger onClick={() => handleDeleteParam(index)} block>
                      ×
                    </Button>
                  </Col>
                </Row>
              ))}
              <Button type="dashed" onClick={handleAddParam} style={{ marginTop: 12 }}>
                + Add Parameter
              </Button>
            </div>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default AddIGGModal;
